module.exports = __webpack_public_path__ + "static/haaste-60a4a9ff715e6a11931880a17e9c6ffc.svg";